// extracted by mini-css-extract-plugin
module.exports = {"root":"TableComponent_root__3KJhs","body":"TableComponent_body__271rd","row":"TableComponent_row__1b3y_","footer":"TableComponent_footer__PksZy"};